/**
 * CMSD static header name.
 *
 * @public
 */
export const CMSD_STATIC = 'CMSD-Static'
